import moment from 'moment';
import Paginate from 'vuejs-paginate';

if($('#component-pipeline-selector-and-history').length){
    var app = new Vue({
        el: '#component-pipeline-selector-and-history',
        data: {
            stages: {},
            stageHistoryRows: {},
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationId: applicationId,
            applicationType: applicationType,
            currentStage: currentStage,
            historyRows: [],
            index: 0
        },
        methods: {
            getStages(){
                var path = location.pathname;
                var type = 1;
                if (path.indexOf('expert-application') !== -1) {
                    type = 2;
                }
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage', {
                    params: {
                        pipelineType: type,
                        pipelineStage: true
                    }
                }).then((response) =>  {
                    this.stages = response.data;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            changeStage(event){
                var stageId = event.target.value;

                var stage = this.stages.filter(stage => {
                    return stage.id == event.target.value
                });

                if(currentStage){
                    this.movedStage(stage[0]);
                }else{
                    this.addedToStage(stage[0]);
                }
            },
            movedStage(stage){
                var array = [];
                stage.items.forEach((value) => {
                    array.push(value.id);
                });
                array.push(this.applicationId);
                var input = {'items':array}

                axios.patch('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage/'+stage.id+'/item/'+this.applicationId+'/move', input, {
                    params: {
                        pipelineStage: true
                    }
                }).then((response) =>  {
                    this.stages = response.data;
                    this.currentStage = stage.id;
                    this.getStages();
                    this.$toasted.success('Item moved to new stage');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            addedToStage(stage){
                axios.patch('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/stage/'+stage.id+'/item/'+applicationId).then((response) =>  {
                    this.stages = response.data;
                    this.currentStage = stage.id;
                    this.$toasted.success('Application added to stage');
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getHistory(pageNum){
                axios.get('/api/v1/network/'+this.networkSlug+'/'+this.applicationType+'/history/'+this.applicationId+'?page='+pageNum).then((response) =>  {
                    this.stageHistoryRows = response.data;

                    for (const element of response.data.data) {
                        this.historyRows[this.index] = element;
                        this.index++;
                    }

                    this.$nextTick(function () {
                        $(".tooltipped").tooltip();
                    });
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('MMM Do, YYYY');
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        mounted () {
            this.getStages();
            this.getHistory();
        },
        components: {
            'paginate': Paginate
        },
    });
}